import type { ReactNode } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

/** 消息和解决记录共用活动布局，保持头像、元信息和正文的对齐。 */
export function TicketActivityEntry({
  author,
  avatarUrl,
  initials,
  time,
  meta,
  busy,
  children,
}: {
  author: string;
  avatarUrl?: string | null;
  initials: string;
  time: string;
  meta: ReactNode;
  busy?: boolean;
  children: ReactNode;
}) {
  return (
    <article aria-busy={busy} className="flex items-start gap-3 py-3">
      <Avatar className="mt-0.5 size-8">
        {avatarUrl ? <AvatarImage alt={author} src={avatarUrl} /> : null}
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
          <span className="text-sm font-medium">{author}</span>
          <span aria-hidden="true" className="text-xs text-muted-foreground">
            ·
          </span>
          <time className="text-xs text-muted-foreground">{time}</time>
          <span aria-hidden="true" className="text-xs text-muted-foreground">
            ·
          </span>
          {meta}
        </div>
        {children}
      </div>
    </article>
  );
}
